export function titleCase(str: String) {
    let first = str[0];
    let sliced = str.substring(1, str.length + 1);

    return first.toUpperCase() + sliced;
}
